"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTimeInSeconds = function () { return Math.floor(Date.now() / 1000); };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pusher/chatkit-server/target/utils.js
// module id = 820
// module chunks = 0